import loadable from '@loadable/component';

export const MainPage = loadable(() => import(/* webpackChunkName: 'MainPage' */ '@pages/MainPage/MainPage'), {
    resolveComponent: ({ MainPage }) => MainPage,
});

export const ProductPage = loadable(() => import(/* webpackChunkName: 'ProductPage' */ '@pages/ProductPage/ProductPage'), {
    resolveComponent: ({ ProductPage }) => ProductPage,
});

export const UserPage = loadable(() => import(/* webpackChunkName: 'UserPage' */ '@pages/UserPage/UserPage'), {
    resolveComponent: ({ UserPage }) => UserPage,
});

export const EditUserPage = loadable(() => import(/* webpackChunkName: 'EditUserPage' */ '@pages/EditUserPage/EditUserPage'), {
    resolveComponent: ({ EditUserPage }) => EditUserPage,
});
